import { Action, Resource, SubscriptionPlan } from '~/api/graphql';

/**
 * Whether the viewer can change seats, voice agents, plan and payment from the
 * Subscription page. Enterprise billing is arranged with Cara directly, so even
 * a subscription admin on that plan has nothing to change there.
 */
export const canSelfServeSubscription = (
  hasPermission: (resource: Resource, action: Action) => boolean,
  plan: SubscriptionPlan | null | undefined
) => hasPermission(Resource.Subscription, Action.Update) && plan !== SubscriptionPlan.Enterprise;
